import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9 1a.9.9 0 0 0-.852.58L6.67 5.32a.915.915 0 0 1-.794.577l-4.017.25c-.828.051-1.166 1.09-.525 1.62l3.102 2.562c.274.226.392.59.303.934L3.736 15.16c-.16.622.332 1.147.887 1.147a.907.907 0 0 0 .49-.146l3.396-2.159a.916.916 0 0 1 .982 0l3.396 2.16a.906.906 0 0 0 .49.145c.555 0 1.047-.525.887-1.147l-1.003-3.896a.915.915 0 0 1 .302-.934l3.103-2.563c.64-.529.303-1.568-.525-1.619l-4.017-.25a.915.915 0 0 1-.794-.577L9.851 1.58A.9.9 0 0 0 9.001 1Zm0 3.946.442 1.12a2.957 2.957 0 0 0 2.556 1.858l1.202.074-.929.768a2.955 2.955 0 0 0-.975 3.004l.3 1.166-1.017-.646a2.934 2.934 0 0 0-3.158 0l-1.017.646.3-1.166a2.955 2.955 0 0 0-.975-3.004L4.8 7.998l1.202-.074a2.957 2.957 0 0 0 2.556-1.858L9 4.946Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
